import React from 'react';
import { Box, Typography } from '@mui/material';

import {
  container,
  containerMobile,
  logoContainer,
  logoImage,
  logoTitle,
} from './styles';
import { conditionalRender } from 'src/utils/ui/conditional-render';
import { LanguageSelect } from 'src/components/language-select';

import { useWindowDimensions } from 'src/utils/ui/dimensions';

import logo from 'src/assets/images/logo.png';
import { HeaderButtonsList } from './header-buttons';
import { genericLabels } from 'src/text/locales/default-en';

const HeaderBar: React.FC = () => {
  const { isMobile } = useWindowDimensions();

  return (
    <Box sx={isMobile ? containerMobile : container}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {conditionalRender(!isMobile, <HeaderButtonsList />)}

        <Box sx={logoContainer}>
          <img src={logo} alt="Logo" style={logoImage} />
          <Typography sx={logoTitle}>{genericLabels.company}</Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        {!isMobile && <LanguageSelect />}
      </Box>
    </Box>
  );
};

export { HeaderBar };
